import { createContext, useEffect, useState } from "react";
interface CheckResponsiveContextProps {
  children: React.ReactNode;
}
//type for CheckResponsiveContext
export interface CheckResponsiveContextType {
  isMobile: boolean | undefined;
  isLandscape: boolean;
}

export const CheckResponsiveContext = createContext(
  {} as CheckResponsiveContextType
);

export const CheckResponsiveContextProvider = ({
  children,
}: CheckResponsiveContextProps) => {
  const [windowDimension, setWindowDimension] = useState<number | null>(null);
  //state maintained to restrict landscape mode in mobileView
  const [isLandscape, setIsLandscape] = useState(false);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  //restrict landscape
  useEffect(() => {
    window
      .matchMedia("(orientation: landscape)")
      .addEventListener("change", (event) => {
        const landScape = event.matches;
        if (landScape) {
          setIsLandscape(true);
        } else {
          setIsLandscape(false);
        }
      });
  }, []);

  const isMobile = windowDimension && windowDimension <= 950 ? true : false;
  return (
    <CheckResponsiveContext.Provider value={{ isMobile, isLandscape }}>
      {children}
    </CheckResponsiveContext.Provider>
  );
};
